export const people = [
  {
    name: "UTKU ATALAY",
    role: "Photographer & Director",
    slug: "utku-atalay",
    description: `
      10 Temmuz 1988 doğumlu Utku Atalay, Üniversite yıllarında başlayan fotoğrafçılık kariyerini ilerletmek için 2012 yılında İzmir’den İstanbul’a taşındı.
      2012-2018 yılları arasında Serkan Şedele’nin yanında fotoğraf asistanlığı yaptıktan sonra 2018 yılında Serkan Şedele’nin yanından ayrılıp kendi ekibini kurdu.
      Moda ve reklam fotoğrafçılığı alanında çalışan Utku Atalay kariyeri süresince Cake (US), Jute (US), Elle, Marie Claire, XOXO gibi dergilere yaptığı moda çekimlerinin yanında BMW, Loreal, Eti, Tchibo, Beko, Grundig, Fenerbahçe, Vakıf Bank, Colins gibi birçok büyük marka için yurtiçi ve yurtdışında çekimler gerçekleştirdi. 2016 yılında henüz asistanken çektiği ilk moda filmi ile Berlin Fashion Film festival seçkisine giren Utku Atalay, yerli ve yabancı bir çok reklam ajansı ile birlikte çalışarak Loreal, Adidas, BMW, Yeni Rakı, Peugeot, Nestle, Beko gibi markalar için reklam filmleri üretti. 
      Fotoğrafçılık ve yönetmenlik kariyerine eş zamanlı olarak devam ediyor.
    `,
    images: Array.from(
      { length: 12 },
      (_, i) => `https://jul.bepanten.net/images/UtkuAtalay/Resim${i + 1}.jpg`
    ),

    videos: [
      "https://vimeo.com/1058214169",
      "https://vimeo.com/941879231",
      "https://vimeo.com/696107438",
      "https://vimeo.com/549623806",
      "https://vimeo.com/725193755",
      "https://vimeo.com/549622260",
      "https://vimeo.com/292898048",
      "https://vimeo.com/906699996",
      "https://vimeo.com/838792218",
      "https://vimeo.com/696107483",
      "https://vimeo.com/432639065",
      "https://vimeo.com/378826176",
      "https://vimeo.com/390284821",
      "https://vimeo.com/838793547",
    ],
  },
  {
    name: "MUSTAFA ÇETİN",
    slug: "mustafa-cetin",
    description: `
      Mustafa, 1986 yılında doğdu ve 2009’da fotoğrafçılığa başladı. 3 yıldan fazla süre asistanlık yaptıktan sonra, 2013 yılında kendi fotoğraf kariyerine başladı. O zamandan beri birçok müşteri ve yayın için fotoğraf çekiyor. 
      Şu anda İstanbul, Türkiye’de yaşıyor ve çalışıyor.
    `,
    images: Array.from(
      { length: 29 },
      (_, i) => `https://jul.bepanten.net/images/MustafaCetin/Resim${i + 1}.jpg`
    ),
  },
  {
    name: "ŞENOL ALTUN",
    slug: "senol-altun",
    role: "Photographer & Director",
    description: `
      Şenol Altun, 20 Nisan 1970 tarihinde Artvin – Şavşat – Veliköy’de dünyaya gelmiştir. İlk ve orta öğretimine orada başlamış ve 15 yaşında ailesiyle birlikte İstanbul’a yerleşip, eğitimine Bakırköy Yahya Kemal Beyatlı Lisesi’nde devam etmiştir. 
      Lise eğitiminden sonra farklı iş ve okul süreçleri olmuştur.      
      1992 yılında Marmara Üniversitesi, Güzel Sanatlar Fakültesi, fotoğraf bölümüne girmeye hak kazanmıştır. 
      Fotoğraf eğitim hayatı boyunca, çeşitli fotoğraf sanatçılarına asistanlık yapmıştır.
      Çekimlerini yaptığı firmalar arasında: Vodafone, Turkcell, THY, Hillside, Altınyıldız, İstanbul Havalimanı gibi muteber markalar bulunmaktadır. 
      2008 yılında Nefes filmi süpervizörlüğünü yürütmüş ve film çekimleri sırasında çektiği fotoğrafları *Nefes- Vatan Sağ Olsun* adıyla kitaplaştırmıştır. 2010 yılında *Çatılardan İstanbul* adlı kitabını yayınlamış, 2011 yılında *Turkish Passport* adlı belgesel filmde görüntü yönetmenliği yapmıştır. 
      2013 yılında *Lambalumba* adını verdiği aydınlatan heykeller tasarımları yapmaya başlamıştır. 
      Bu eserlerini 2014 ve 2017 yıllarında açtığı 2 kişisel sergi ile sanatseverler ile buluşturmuştur. Bununla beraber çeşitli karma sergilerde eserleri yer almıştır. Halen fotoğraf ve reklam film yönetmenliği kariyerine ve aydınlatan heykeller tasarımlarına devam etmektedir.
      1 çocuk babasıdır.
    `,
    images: Array.from(
      { length: 38 },
      (_, i) => `https://jul.bepanten.net/images/SenolAltun/Resim${i + 1}.jpg`
    ),

    videos: [
      "https://vimeo.com/775871517",
      "https://vimeo.com/783900257",
      "https://vimeo.com/780332911",
      "https://vimeo.com/780329695",
      "https://vimeo.com/775863932",
      "https://vimeo.com/780325593",
      "https://vimeo.com/780324689",
      "https://vimeo.com/775876781",
      "https://vimeo.com/775874328",
      "https://vimeo.com/783901360",
      "https://vimeo.com/780331201",
    ],
  },
  {
    name: "FETHİ KARADUMAN",
    slug: "fethi-karaduman",
    description: `
      Fethi Karaduman, 18 Haziran 1979 tarihinde doğdu ve İstanbul merkezli bir reklam, güzel sanatlar ve portre fotoğrafçısıdır. 
      Türkiye’de doğan Karaduman, eğitimini Singapur ve Güney Afrika’da aldığı için Uzak Doğu ve Afrika kültürlerinden büyük ölçüde etkilendi. Witwatersrand Üniversitesi’nde Mimarlık Çalışmaları lisansını tamamladıktan sonra Karaduman, on yıl boyunca özel sektörde kariyerine devam etti. 
      Bu yıllarda amatör fotoğrafçılıkla da deneyler yapmaya başladı.      
      Karaduman, 2008-2018 yılları arasında fotoğrafçı Mehmet Turgut ile çalıştı ve Magazine 46 için Fotoğraf Baş Editörü olarak görev yaptı. Karaduman’ın müşteri portföyü arasında Fox Türkiye, Doğan Yayın, Hürriyet, Nike Türkiye, Faber-Castell ve Gillette gibi ticari markalar yer alıyor. 
      Ayrıca birçok yerli ve yabancı ünlü, sanatçı ve yazar için portre çalışmalarıyla tanınmaktadır.
    `,
    images: Array.from(
      { length: 40 },
      (_, i) =>
        `https://jul.bepanten.net/images/FethiKaraduman/Resim${i + 1}.jpg`
    ),
  },
  {
    name: "SİNEM YAZICI",
    slug: "sinem-yazici",
    description: `
      Sinem Yazici, 1976 yılında Antalya’da doğdu. Marmara Üniversitesi İletişim Fakültesi Halkla İlişkiler ve Reklamcılık Bölümü’nden mezun oldu. 1996 yılından itibaren reklam kariyeri 14 yıl boyunca devam etti ve birçok uluslararası ajansda çalıştı. Aynı zamanda yerel ve küresel üne sahip markaların reklam yöneticisi olarak görev aldı. Sinem’in fotoğrafa olan ilgisi, İstanbul’da aldığı bir fotoğrafçılık dersiyle başladı ve bu yeni bir dönemin kapısını araladı. New York Film Akademisi’nde fotoğraf eğitimini tamamlamak için New York’a gitti. Sinem’in fotoğrafçılığı, beden ve kumaş hikayeleri aracılığıyla insan ruhunun keşfidir.
2017 yılında Wepublic kampanya fotoğrafıyla Türkiye’nin en prestijli reklam ödülü olan “Kristal Elma” ödülünü kazandı.
Ayrıca “Model Taste” adlı platformun kurucusudur. Bu platformda modelleri New York hakkında röportajlar yapmaktadır (www.modeltaste.com).
Sinem Yazici, şu anda İstanbul ve New York’ta serbest moda ve reklam fotoğrafçılığı yapmaktadır.
    `,
    images: Array.from(
      { length: 31 },
      (_, i) => `https://jul.bepanten.net/images/SinemYazici/Resim${i + 1}.jpg`
    ),

    // images: ["/images/SinemYazici/resim1.jpg",
    // ],
  },
  {
    name: "ÇAĞ ÇALIŞKUR",
    slug: "cag-caliskur",
    role: "Director",
    description: `
      Çağ, 18 Mayıs 1982 tarihinde Ankara’da doğdu. 4 yaşında ritmik jimnastiğe, 6 yaşında baleye, 10 yaşında yüzmeye başladı ve 17 yaşında Türkiye bilardo şampiyonu oldu. İstanbul Kültür Üniversitesi Uluslararası İlişkiler bölümüne girdi ve sporcu bursu kazandı. Mezun olduktan sonra bir süre Radikal gazetesinde muhabir olarak çalıştı. 2006’da oyunculuk eğitimi almak üzere Amerika’ya gitti ve New York City - Sanford Meisner Technique okulunda ve American Academy of Dramatic Arts’ta oyunculuk teknikleri üzerine eğitim aldı. 
      2008’de mezun olduktan sonra Türkiye’ye döndü.
      Çağ Çalışkur, DOT, İstanbul Devlet Tiyatroları ve çeşitli televizyon dizilerinde oyuncu olarak görev aldı. 2011 yılında CRAFT oyunculuk atölyesini açtı. 
      Şu anda Craft Tiyatro'da genel sanat yönetmeni olarak görevini sürdürmektedir.

      Ödülleri arasında 2019 Afife Jale Tiyatro Ödülleri’nde “Yılın En Başarılı Yönetmeni” ödülü de bulunuyor. Ayrıca yönettiği bazı tiyatro oyunları şunlardır:
      - Waterproof
      - Shakespeare Müzesi
      - Fotoğraf 51
      - Yen
      - Yutmak
      - 10 11 12
      - Hepimizin Öyküsü Aynı
      - Personel
      - Kalp Düğümü
      - Enkaz
      - Kabin
      - Kayıp
      - Vur / Yağmala / Yeniden
    `,
    images: [],
    videos: [
      "https://www.youtube.com/watch?v=ZRsqoXNpCd8",
      "https://www.youtube.com/watch?v=HqL4NELaFVo",
    ],
  },
  {
    name: "ÇAĞRI ARK",
    role: "Director",
    slug: "cagri-ark",
    description: `Çağrı, yeni ufuklar açan yaratıcı fikirler üzerinde çalışmayı seven bir Fransızca konuşan yönetmendir. 
    Galatasaray Lisesi’nden mezun olduktan sonra sinema eğitimi almak için Fransa’ya gitmiştir.
    Türkiye’ye döndüğünde, Turkish Airlines için dünya çapında projelerde ajans yapımcısı olarak çalıştı. Aynı zamanda Turkish Airlines - Kobe vs Messi adlı en çok izlenen reklamın ekibinde yer aldı.
    Daha sonra tüm bilgi ve deneyimini tam zamanlı yönetmen olarak kullanmaya karar verdi. Pepsi, Tropicana, Varyap gibi tanınmış yerel ve uluslararası markalar için birçok reklam yönetmenliği yapmıştır.
    Çağrı’nın Fiat için hazırladığı Babalar Günü projesi 2014 yılında bir Kristal Elma ödülü kazandı.
    Yeni hikayeler anlatmak için sabırsızlanıyor ve yaratıcı projeler geliştirmesiyle tanınıyor.`,
    videos: [
      "https://vimeo.com/262432894",
      "https://vimeo.com/217923864",
      "https://vimeo.com/353661575",
      "https://vimeo.com/1026517285",
      "https://vimeo.com/358303143",
      "https://vimeo.com/954325315",
      "https://vimeo.com/583337788",
      "https://vimeo.com/666688126",
      "https://vimeo.com/775519109",
      "https://vimeo.com/266936753",
      "https://vimeo.com/666689558",
      "https://vimeo.com/277099222",
      "https://vimeo.com/717859216",
      "https://vimeo.com/439949459",
      "https://vimeo.com/717842673",
      "https://vimeo.com/258493665",
      "https://vimeo.com/236546927",
      "https://vimeo.com/583342131",
      "https://vimeo.com/307304060",
      "https://vimeo.com/378378907",
      "https://vimeo.com/368755662",
      "https://vimeo.com/342198185",
      "https://vimeo.com/169721654",
      "https://vimeo.com/169721162",
      "https://vimeo.com/927957006",
      "https://vimeo.com/927953274",
      "https://vimeo.com/927951899",
    ],
    images: [], // Directors için images boş bırakılabilir veya kaldırılabilir
  },
  {
    name: "CAN ÇİÇEK",
    role: "Photographer",
    slug: "can-cicek",
    description: `Can Çiçek 1987 yılında doğdu. 2007 yılında Çanakkale 18 Mart Üniversitesi Fotoğrafçılık bölümünden mezun olduktan sonra kariyerine birçok usta fotoğrafçının asistanlığını yaparak başladı. 
      2013 yılından bu yana Türkiye ve yurtdışında birçok global ajansla birçok markanın reklam kampanyalarını gerçekleştirdi. 
      Şu anda 2015 yılında kurduğu kendi şirketinde projelerine devam ediyor.`,
    images: Array.from(
      { length: 24 },
      (_, i) => `https://jul.bepanten.net/images/CanCicek/Resim${i + 1}.jpg`
    ),
  },
  {
    name: "EKİN CAN BAYRAKDAR",
    role: "Photographer",
    slug: "ekin-can-bayrakdar",
    description: `Londra'da yaşayan moda ve güzellik fotoğrafçısı Ekin Can Bayrakdar, uluslararası yayınlara ve moda ve güzellik markalarına yaptığı katkılarla tanınıyor. Lüks sadeliğiyle bilinen çalışmaları Vogue Arabia, Vogue Portugal, Vogue Turkey, Harper's Bazaar Arabia, Harper's Bazaar Hong Kong, Elle Croatia, Elle Bulgaria ve L'Officiel Magazines gibi saygın dergilerde yer aldı.
Güzel sanatlar geçmişine sahip olan Ekin, projelerine benzersiz bir bakış açısı getirmekte, sürekli olarak yenilikçi fikirler sunmakta ve farklı ekiplerle etkili bir şekilde işbirliği yapmaktadır. Kendisini yaratıcı sınırları zorlamaya ve müşterilerinin vizyonlarının hayata geçmesini sağlamaya adamıştır. 
Ekin'in yetenekli bir fotoğrafçı olarak ünü, izleyicileri büyüleyen görsel olarak çarpıcı görüntüler üretme konusundaki kararlılığına dayanmaktadır.`,

    images: Array.from(
      { length: 75 },
      (_, i) =>
        `https://jul.bepanten.net/images/EkinCanBayrakdar/resim${i + 1}.jpg`
    ),
  },
  {
    name: "ONUR AYNAGÖZ",
    role: "Photographer",
    slug: "onur-aynagoz",
    description: `Londra'da yaşayan moda ve güzellik fotoğrafçısı Ekin Can Bayrakdar, uluslararası yayınlara ve moda ve güzellik markalarına yaptığı katkılarla tanınıyor. Lüks sadeliğiyle bilinen çalışmaları Vogue Arabia, Vogue Portugal, Vogue Turkey, Harper's Bazaar Arabia, Harper's Bazaar Hong Kong, Elle Croatia, Elle Bulgaria ve L'Officiel Magazines gibi saygın dergilerde yer aldı.
Güzel sanatlar geçmişine sahip olan Ekin, projelerine benzersiz bir bakış açısı getirmekte, sürekli olarak yenilikçi fikirler sunmakta ve farklı ekiplerle etkili bir şekilde işbirliği yapmaktadır. Kendisini yaratıcı sınırları zorlamaya ve müşterilerinin vizyonlarının hayata geçmesini sağlamaya adamıştır. 
Ekin'in yetenekli bir fotoğrafçı olarak ünü, izleyicileri büyüleyen görsel olarak çarpıcı görüntüler üretme konusundaki kararlılığına dayanmaktadır.`,

    images: Array.from(
      { length: 72 },
      (_, i) => `https://jul.bepanten.net/images/OnurAynagoz/Resim${i + 1}.jpg`
    ),
  },
];
